import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import ACCESS from '../../../ACCESS.js';

class GuiasTransportista extends TableComponent {

  componentDidMount() {
    this.configTable();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.idTransportista !== this.props.idTransportista)
      this.configTable();
  }

  configTable = () => {
    this.tableConfig(
      { dataUrl: `pago-transportista/guia/filter?id_transportista=${this.props.idTransportista}`, deleteUrl: 'banco/delete', deleteField: 'banco_nombre', modUrl: '/Catalogo/Banco' },
      TableOp.Table('', [
        { label: 'Folio', id: 'g_folio' },
        // { label: 'Banco', id: 'banco' },
      ], [
        // { id: 'edit', icon: 'plus' },
        { id: 'add', icon: 'add', cb: this.onAddGuia, acces: [ACCESS.COBRANZA_PAGO_TRANSPORTISTA.PAGO_ENTREGA] },
      ]))
    this.table();
  }

  onAddGuia = (a, row) => {
    this.props.onAddGuia(row.id);
  }

  onCreatePago = () => {
    this.setState({ modalPago: { visible: true } });
  }

  onPagoClose = () => {
    this.setState({ modalPago: { visible: false } });

  }

  render() {
    return (
      <div>
        <h5>Seleccionar guías</h5>
        <div>
          <this.TableRender />
        </div>
      </div>
    )
  }
}

export default withRouter(GuiasTransportista)